var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),_c('post-list',{attrs:{"category":"BBEE Productos y Servicios - Medios de Pago"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }